// `/app/splits/$id` (WEB-123): CONTEÚDO do `RouteDrawer` da rota-pai. A lista continua
// desenhada embaixo, inclusive em deep link. De que ponta o seller está vem do `tab` do
// `search` herdado: a visão da API é a mesma nas duas (`19` §5.2), e o default (`received`)
// é o lado seguro, sem link para a transação.

import { useQuery } from '@tanstack/react-query';
import { createFileRoute, useSearch } from '@tanstack/react-router';
import { isApiError } from '../api/errors.ts';
import { splitQueryOptions } from '../api/queries/splits.ts';
import { useMode } from '../app/mode.tsx';
import { EmptyState } from '../components/app/empty-state.tsx';
import { ErrorState } from '../components/app/error-state.tsx';
import { CardSkeleton } from '../components/app/skeletons.tsx';
import { Split as SplitIcon } from '../components/icons/index.tsx';
import { TransactionLink } from '../features/splits/links.tsx';
import { SplitDetail } from '../features/splits/split-detail.tsx';

function SplitPage() {
  const { id } = Route.useParams();
  const { mode } = useMode();
  const search = useSearch({ from: '/app/splits' });
  const role = search.tab === 'paid' ? 'paid' : 'received';

  const detail = useQuery(splitQueryOptions(mode, id));

  if (detail.isPending) {
    return <CardSkeleton lines={4} />;
  }

  // 404 pelo `code`: split de outro seller ou do outro modo (`19` §5.3).
  if (isApiError(detail.error) && detail.error.code === 'resource_not_found') {
    return (
      <EmptyState
        bare
        icon={SplitIcon}
        title="Split não encontrado"
        description="Este split não existe nesta conta ou está no outro modo (Produção/Teste)."
      />
    );
  }

  if (detail.error !== null || detail.data === undefined) {
    return (
      <ErrorState
        error={detail.error}
        onRetry={() => {
          void detail.refetch();
        }}
      />
    );
  }

  return (
    <SplitDetail
      split={detail.data}
      side={role}
      {...(role === 'paid'
        ? {
            transactionLink: (
              <TransactionLink id={detail.data.transaction.id} label="Abrir a cobrança" />
            ),
          }
        : {})}
    />
  );
}

export const Route = createFileRoute('/app/splits/$id')({ component: SplitPage });
